import { baseApi } from "../baseApi";
import { DataPalencaGigWidgetUrl, PalencaGigWidgetUrlResponse, Response } from "@interfaces/index";

export interface CiecValidatorRequest {
  rfc: string;
  ciec: string;
  loan_application_id: string;
  application_code: string;
  client_details_id: string;
  loan_application_conditions_id: string;
  requested_amount?: number;
  requested_term?: number;
  validate_ciec?: boolean;
  company_id?: string;
  connection_is_mobile_app?: boolean;
  person_id?: string;
  is_ciec_required?: boolean;
}

interface LoanApplicationPF {
  mortgage_credit: boolean;
  automotive_credit: boolean;
  credit_card: boolean;
  last_four_digits: string | null;
}

export interface BuroValidatorRequestPF {
  person_Type: "pf";
  data: {
    rfc: string;
    curp?: string;
    transaction_number: string;
    application_code: string;
    legal_name: string;
    first_name: string;
    second_name: string;
    father_last_name: string;
    mother_last_name: string;
    reenter_NIP: boolean;
    authorization_label_response: boolean;
    loan_application_id: string;
    person_id?: string;
    is_endorsement?: boolean;
    pf?: LoanApplicationPF;
    address: {
      street: string;
      interiorNumber: string;
      exteriorNumber: string;
      state: string;
      municipality: string;
      locality: string;
      postalCode: string;
    };
  };
}

export interface BuroValidatorRequestPFAE {
  person_Type: "pfae" | "pf";
  data: {
    rfc: string;
    transaction_number: string;
    legal_name: string;
    first_name: string;
    second_name: string;
    father_last_name: string;
    mother_last_name: string;
    reenter_NIP: boolean;
    authorization_label_response: boolean;
    loan_application_id: string;
    is_endorsement: boolean;
    person_id?: string;
    application_code?: string;
    immediate?: boolean;
    address?: {
      street: string;
      interiorNumber: string;
      exteriorNumber: string;
      state: string;
      municipality: string;
      locality: string;
      postalCode: string;
    };
  };
}

export interface BuroReconsultationRequest {
  rfc: string;
  loan_application_id: string;
  application_code: string;
  person_type: string;
}

export interface PalencaGigWidgetUrlRequest {
  loan_application_id: string;
  plattform: string;
}

const satApiNew = baseApi.injectEndpoints({
  endpoints: (build) => ({
    ciecValidator: build.mutation<Response, CiecValidatorRequest>({
      query: (data) => ({
        url: `sat_core/ciec_validator`,
        method: "POST",
        body: data,
      }),
    }),
    buroValidator: build.mutation<Response, BuroValidatorRequestPF | BuroValidatorRequestPFAE>({
      query: ({ person_Type, data }) => ({
        url: `sat_core/credit_bureau_authorization/${person_Type}`,
        method: "POST",
        body: data,
      }),
    }),
    buroReconsultation: build.mutation<Response, BuroReconsultationRequest>({
      query: (data) => ({
        url: `sat_core/credit_bureau_reconsult_authorization`,
        method: "POST",
        body: {
          rfc: data.rfc,
          loan_application_id: data.loan_application_id,
          retry_application_code: data.application_code,
          person_type: data.person_type,
        },
      }),
    }),
    palencaGigWidgetUrl: build.query<DataPalencaGigWidgetUrl | null, PalencaGigWidgetUrlRequest>({
      query: ({ loan_application_id, plattform }) => ({
        url: `sat_core/palenca-gig-widget-url/${loan_application_id}`,
        method: "GET",
        params: { plattform },
      }),
      transformResponse: (response: PalencaGigWidgetUrlResponse) => {
        return response?.data?.data?.[0] ?? null;
      },
    }),
  }),
});

export const {
  useCiecValidatorMutation,
  useBuroValidatorMutation,
  useBuroReconsultationMutation,
  useLazyPalencaGigWidgetUrlQuery,
} = satApiNew;
